const FollowStore = {
  init() {
    this.bindEvents()
  },

  bindEvents() {
    $(document).on('click', '.btn-follow-store', function (e) {
      e.preventDefault()

      let $this = $(this)
      let url = $this.data('url')

      if ($this.prop('disabled')) {
        return
      }

      $this.prop('disabled', true)

      $.ajax({
        url: url,
        type: 'POST',
        data: {
          _token: $('meta[name="csrf-token"]').attr('content'),
        },
        success: function (response) {
          if (response.error) {
            if (response.next_url) {
              window.location.href = response.next_url
              return
            }

            if (typeof Theme !== 'undefined' && Theme.showError) {
              Theme.showError(response.message)
            } else if (typeof showToast === 'function') {
              showToast(response.message, 'error')
            } else {
              alert(response.message)
            }
          } else {
            if (typeof Theme !== 'undefined' && Theme.showSuccess) {
              Theme.showSuccess(response.message)
            } else if (typeof showToast === 'function') {
              showToast(response.message, 'success')
            } else {
              alert(response.message)
            }

            let followText = window.Trans && window.Trans.follow ? window.Trans.follow : 'Follow'
            let unfollowText = window.Trans && window.Trans.unfollow ? window.Trans.unfollow : 'Unfollow'

            if (!response.data.is_followed) {
              $this.css('background-color', '')
              $this.find('.label').text(followText)
              $this.find('.follow-icon').html('<i class="ti ti-plus"></i>')
            } else {
              $this.css('background-color', '#eee')
              $this.find('.label').text(unfollowText)
              $this.find('.follow-icon').html('<i class="ti ti-check"></i>')
            }
            $('.followers-count-' + response.data.store_id).text(response.data.followers_count)
          }
        },
        error: function (response) {
          let message = 'Something went wrong. Please try again later.'
          if (response.responseJSON && response.responseJSON.message) {
            message = response.responseJSON.message
          }

          if (typeof Theme !== 'undefined' && Theme.showError) {
            Theme.showError(message)
          } else if (typeof showToast === 'function') {
            showToast(message, 'error')
          } else {
            alert(message)
          }
        },
        complete: function () {
          $this.prop('disabled', false)
        },
      })
    })
  },
}

$(document).ready(() => FollowStore.init())
